@if (!(isLoading$ | async)) {
  <div class="edit-form__wrapper grid grid-cols-1 divide-y bg-white">
    @if ((jointAccountData$ | async) !== null) {
      <div class="hidden"></div>
      <app-edit-joint-customer-information
        [personalDetails]="personalDetails"
      ></app-edit-joint-customer-information>
      <app-edit-joint-location
        [locationDetails]="locationDetails"
        [jointAccountId]="(jointAccountId$ | async)!"
      ></app-edit-joint-location>
      <app-edit-joint-means-of-id
        [jointDataDetails]="jointDataDetails"
      ></app-edit-joint-means-of-id>
      <app-edit-joint-employment
        [employmentDetails]="employmentDetails"
        [jointAccountId]="(jointAccountId$ | async)!"
      ></app-edit-joint-employment>
      <app-edit-joint-kin
        [nextOfKinDetails]="nextOfKinDetails"
        [jointAccountId]="(jointAccountId$ | async)!"
      ></app-edit-joint-kin>
      <app-edit-bank-details
        [bankDetails]="bankDetails"
      ></app-edit-bank-details>
      <app-edit-signatory-details
        [signatoriesList]="signatoriesList"
      ></app-edit-signatory-details>
      <app-edit-joint-docs
        [kycDocuments]="documentDetails"
        [jointDataDetails]="jointDataDetails"
      ></app-edit-joint-docs>

      <div></div>
    }
  </div>
} @else {
  <div class="flex flex-col">
    <ngx-skeleton-loader
      *ngFor="let in of [0, 1, 2, 3, 4, 5, 6]; let i = index"
      [theme]="{ height: '5rem', width: '100%' }"
    ></ngx-skeleton-loader>
  </div>
}
